import React, { useState, useEffect } from 'react';
import {
  Card,
  Badge,
  Button,
  Table,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle, CardHeader,
} from "reactstrap";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import CircleChart from "dashboard/hr-management/variables/circlebar";
import { api } from '../../../../api';
import * as XLSX from "xlsx";
import Cookies from 'js-cookie';



const Materials4 = () => {



  const [matdata, setmatdata] = useState();

  const emp_id = Cookies.get("token");
  const g_m_id = Cookies.get("token");


  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [allData, setFilteredData] = useState([]);

  // Filter states
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [materialNameFilter, setMaterialNameFilter] = useState("");
  const [materialFilterDropdownOpen, setMaterialFilterDropdownOpen] = useState(false);
  const [dateRangeModalOpen, setDateRangeModalOpen] = useState(false);
  const [materialSearchQuery, setMaterialSearchQuery] = useState("");

  const [material, setMaterial] = useState([]);
  const [change, setChange] = useState([]);
  const [materialShow, setMaterialShow] = useState([]);
  const toggleDropdown = (index) => {
    setDropdownOpen(prevState => ({
      ...prevState,
      [index]: !prevState[index]
    }));
  }

  const [countDetails, setcountDetails] = useState();
   // Pgination code from here
   const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
   const [dataToShow, setDataToShow] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const [filteredDataLength, setFilteredDataLength] = useState(0); // Track filtered data length for pagination
   const [entriesToShow, setEntriesToShow] = useState(5);
   const [entriesDropdownOpen, setEntriesDropdownOpen] = useState(false);
   const [showWasteFields, setShowWasteFields] = useState(false);
   const [showReplaceFields, setShowReplaceFields] = useState(false);
   const [projects, setProjects] = useState([]);
   const [selectedProject, setSelectedProject] = useState("all");
  //  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
   useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const company_id = Cookies.get('company_id');
      const [
        response1All,
        response1Count,
        response2All,
        response2Count
      ] = await Promise.all([
        api.get(`materailsdetailsstore.php?all='all'&company_id=${company_id}`),
        api.get(`materailsdetailsstore.php?company_id=${company_id}`),
        api.get(`getMaterialFileUploadStore.php?all='all'&company_id=${company_id}`),
        api.get(`getMaterialFileUploadStore.php?company_id=${company_id}`)
      ]);

      // Combine data for table
      const combinedData = [
        ...(Array.isArray(response1All.data) ? response1All.data : []),
        ...(Array.isArray(response2All.data) ? response2All.data : [])
      ];
      setFilteredData(combinedData);

      // --- Extract unique projects ---
      // Assumes each item has p_id and project_name
      const projectMap = {};
      combinedData.forEach(item => {
        if (item.p_id && item.p_name) {
          projectMap[item.p_id] = item.p_name;
        }
      });
      const projectList = Object.entries(projectMap).map(([p_id, p_name]) => ({
        p_id,
        p_name
      }));
      setProjects(projectList);
      // --- End extract unique projects ---

      // Combine counts for cards
      const count1 = Array.isArray(response1Count.data) && response1Count.data.length > 0 ? response1Count.data[0] : {};
      const count2 = Array.isArray(response2Count.data) && response2Count.data.length > 0 ? response2Count.data[0] : {};

      const combinedCount = {
        total_request: (parseInt(count1.total_request) || 0) + (parseInt(count2.total_request) || 0),
        Amount_spent: (parseFloat(count1.Amount_spent) || 0) + (parseFloat(count2.amount_spent) || 0),
        Approved_request: (parseInt(count1.Approved_request) || 0) + (parseInt(count2.approved_request) || 0),
        Pending_request: (parseInt(count1.Pending_request) || 0) + (parseInt(count2.pending_request) || 0)
      };

      setcountDetails([combinedCount]);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  fetchData();
}, [searchQuery]);


useEffect(() => {
  let filtered = allData;
  
  // Apply project filter
  if (selectedProject !== "all") {
    filtered = filtered.filter(item => item.p_id === selectedProject);
  }
  
  // Apply search filter
  if (searchQuery.trim() !== "") {
    const searchQueryLower = searchQuery.toLowerCase();
    filtered = filtered.filter((item) => {
      const matchName = item?.mat_name?.toLowerCase()?.includes(searchQueryLower) || false;
      const matchStatus = item?.store_status?.toLowerCase()?.includes(searchQueryLower) || false;
      const matchFileName = item?.mat_fileName?.toLowerCase()?.includes(searchQueryLower) || false;
      return matchName || matchStatus || matchFileName;
    });
  }
  
  // Apply date and material name filters
  filtered = applyFilters(filtered);
  
  // Sort filtered data in descending order by Date_Time
  const sortedFilteredData = filtered.sort((a, b) => {
    const dateA = new Date(a.Date_Time);
    const dateB = new Date(b.Date_Time);
    return dateB - dateA; // Descending order (newest first)
  });
  
  // Set filtered data length for pagination
  setFilteredDataLength(sortedFilteredData.length);
  
  let paginated = sortedFilteredData;
  if (entriesToShow !== filteredDataLength) {
    const startIndex = (currentPage - 1) * entriesToShow;
    const endIndex = startIndex + entriesToShow;
    paginated = sortedFilteredData.slice(startIndex, endIndex);
  }
  setDataToShow(paginated);
}, [allData, entriesToShow, currentPage, selectedProject, searchQuery, startDate, endDate, materialNameFilter]);

  const [itemIdToDelete, setItemIdToDelete] = useState(null);

  const handleDeleteIconClick = (role_id) => {
    setItemIdToDelete(role_id);
    setShowDeleteConfirmation(true);
  };

  const handleDeleteConfirmation = (e) => {
    // e.preventDefault();
    // Implement delete logic here
    const roleid = itemIdToDelete;
    if (roleid != null) {
      const fetchData = async () => {
        try {
          const company_id = Cookies.get('company_id');
          const response = await api.get(`addRole.php?roleid=${roleid}&company_id=${company_id}`);
          console.log(response.data);
          window.location.reload();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
    setItemIdToDelete(null);
    setShowDeleteConfirmation(false);
  };

  const [showRoleModal, setShowRoleModal] = useState(false);

  const toggleRole = () => {
    setShowRoleModal(!showRoleModal);
  };

  const [selectedId, setSelectedId] = useState(null);

  const [report, setreport] = useState();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setreport((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    console.log(report)
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const company_id = Cookies.get('company_id');
      const response = await api.post(`materialreport.php?company_id=${company_id}`, report);
      console.log("Data sent successfully:", response.data);
      // window.location.reload();
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleItemClick = (id) => {
    // setSelectedId(id);
    setreport((prevState) => ({
      ...prevState,
      id : id,
    }));
    toggleModal();
  };

  const [viewrole, setviewrole] = useState();
  const [loading, setLoading] = useState(true);








  const [totalEmployees, setTotalEmployees] = useState(0);
  const [onTime, setOnTime] = useState(0);
  const [late, setLate] = useState(0);
  const [leaves, setLeaves] = useState(0);




  const handleStatusAction = async (e) => {
    e.preventDefault();
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.post('materialreport.php', { ...report, company_id });
      console.log("Data sent successfully:", response.data);
      window.location.reload();
    } catch (error) {
      console.error("Error submitting data:", error);
    }
    // window.location.reload();
  };


 


  // useEffect(() => {

  //   setDataToShow(allData.slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow));
  // }, [entriesToShow, currentPage, allData.length]);



  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const toggleEntriesDropdown = () => {
    setEntriesDropdownOpen(!entriesDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(value === 'All' ? filteredDataLength : Number(value));
    setCurrentPage(1);
  };


  const handleDropdownToggle = (index) => {
    setDataToShow((prevData) => {
      const newData = [...prevData];
      newData[index].dropdownOpen = !newData[index].dropdownOpen;
      return newData;
    });
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    const totalPages = Math.ceil(filteredDataLength / entriesToShow);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  // Filter toggle functions
  const toggleDateRangeModal = () => {
    setDateRangeModalOpen(!dateRangeModalOpen);
  };

  const toggleMaterialFilterDropdown = () => {
    setMaterialFilterDropdownOpen(!materialFilterDropdownOpen);
  };

  // Get unique material names for filter dropdown with search
  const getUniqueMaterialNames = () => {
    let names = [...new Set(allData.map(item => item.mat_name || item.mat_fileName).filter(Boolean))];
    
    // Apply search filter if there's a search query
    if (materialSearchQuery.trim()) {
      names = names.filter(name => 
        name.toLowerCase().includes(materialSearchQuery.toLowerCase())
      );
    }
    
    return names.sort();
  };

  // Apply filters
  const applyFilters = (data) => {
    let filtered = [...data];

    // Apply date range filter
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        if (item.Date_Time) {
          // Parse the item date and normalize to YYYY-MM-DD format
          const itemDate = new Date(item.Date_Time);
          const itemDateStr = itemDate.toISOString().split('T')[0]; // Get YYYY-MM-DD format
          
          if (startDate && endDate) {
            // Both start and end date selected
            // Normalize both dates to YYYY-MM-DD format for accurate comparison
            const startDateStr = startDate; // Already in YYYY-MM-DD format
            const endDateStr = endDate; // Already in YYYY-MM-DD format
            
            // For same day selection (start === end), we want to include the entire day
            if (startDateStr === endDateStr) {
              return itemDateStr === startDateStr;
            } else {
              return itemDateStr >= startDateStr && itemDateStr <= endDateStr;
            }
          } else if (startDate) {
            // Only start date selected - from start date to current date
            const startDateStr = startDate;
            return itemDateStr >= startDateStr;
          } else if (endDate) {
            // Only end date selected - from beginning to end date
            const endDateStr = endDate;
            return itemDateStr <= endDateStr;
          }
        }
        return false;
      });
    }

    // Apply material name filter
    if (materialNameFilter) {
      filtered = filtered.filter(item => {
        const materialName = item.mat_name || item.mat_fileName || '';
        return materialName.toLowerCase().includes(materialNameFilter.toLowerCase());
      });
    }

    return filtered;
  };

  // Clear all filters
  const clearFilters = () => {
    setStartDate("");
    setEndDate("");
    setMaterialNameFilter("");
    setMaterialSearchQuery("");
  };

  // Apply date range filter
  const applyDateRange = () => {
    setDateRangeModalOpen(false);
  };

  // Get date range display text
  const getDateRangeText = () => {
    if (startDate && endDate) {
      return `${new Date(startDate).toLocaleDateString()} - ${new Date(endDate).toLocaleDateString()}`;
    } else if (startDate) {
      return `From ${new Date(startDate).toLocaleDateString()}`;
    } else if (endDate) {
      return `Until ${new Date(endDate).toLocaleDateString()}`;
    }
    return "Filter by Date Range";
  };

  const handleDownload = () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const fileName = 'material_list';

    // Convert dataToShow to the format needed for XLSX.utils.json_to_sheet
    const formattedData = allData && allData?.map((item,index) => ({
      'Sl.No': ++index,
      'Item Name': item.mat_name,
      'Quantity': item.mat_quantity,
      'Cost ': item.mat_money,
      'Requested On': item.Date_Time,
      'Priority': item.Priority
    }));

    // Create a worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData, {
      header: ['Sl.No', 'Item Name', 'Quantity', 'Cost','Requested On','Priority'],
    });

    // Create a workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Material List');

    // Apply bold and background color to headers
    const headerCellStyle = { font: { bold: true }, fill: { bgColor: { indexed: 64 } } };
    Object.keys(ws).filter((key) => key.startsWith('A1')).forEach((key) => {
      ws[key].s = headerCellStyle;
    });

    // Convert the workbook to a binary Excel file
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Create a Blob from the Excel buffer
    const excelData = new Blob([excelBuffer], { type: fileType });

    // Create a URL for the Blob
    const excelUrl = URL.createObjectURL(excelData);

    // Create a link and trigger the download
    const link = document.createElement('a');
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const getSerialNumber = (index) => {
    return (currentPage - 1) * entriesToShow + index + 1;
  };

const statusOptions = [
  { value: "Approved", label: "Accept" },
  { value: "Rejected", label: "Reject" }
];

const getStatusBadge = (status) => {
  switch (status) {
    case 'pending':
      return <Badge color='warning'>{status}</Badge>;
    case 'Approved':
      return <Badge color='success'>{status}</Badge>;
    case 'Rejected':
      return <Badge color='danger'>{status}</Badge>;
    default:
      return <Badge color='secondary'>{status}</Badge>;
  }
};

const [modalOpen, setModalOpen] = useState(false);
const [selectedproject, setselectedproject] = useState();
const [modal, setModal] = useState(false); // State to control modal visibility
const [modalEmployee, setModalEmployee] = useState(null);

// Multiple materials modal states
const [isMultipleMaterials, setIsMultipleMaterials] = useState(false);
const [multipleMaterialsData, setMultipleMaterialsData] = useState(null);
const [modalCurrentPage, setModalCurrentPage] = useState(1);
const [modalEntriesPerPage, setModalEntriesPerPage] = useState(5);
const [modalEntriesDropdownOpen, setModalEntriesDropdownOpen] = useState(false);

const toggleModalView = () => {
    setModalOpen(!modalOpen);
};

const toggleModal = () => {
    setModal(!modal);
};

// Multiple materials functions
const handleDownloadMultipleMaterials = () => {
  if (!multipleMaterialsData) return;

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const fileName = "multiple_materials_list";

  const materialsForExport = multipleMaterialsData.materials.map((material, index) => ({
    "Sr. No": index + 1,
    "Material Name": material.mat_name || "N/A",
    "Quantity": material.mat_quantity || "N/A",
    "Budget": material.mat_money || "N/A",
    "Unit Price": parseFloat(material.mat_money) || 0,
    "Total": (parseFloat(material.mat_quantity) || 0) * (parseFloat(material.mat_money) || 0)
  }));

  const ws = XLSX.utils.json_to_sheet(materialsForExport);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const excelData = new Blob([excelBuffer], { type: fileType });
  const excelUrl = URL.createObjectURL(excelData);
  const link = document.createElement("a");
  link.href = excelUrl;
  link.download = fileName + fileExtension;
  document.body.appendChild(link);
  link.click();
  setTimeout(function () {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(excelUrl);
  }, 100);
};

const getModalPaginatedMaterials = () => {
  const startIndex = (modalCurrentPage - 1) * modalEntriesPerPage;
  const endIndex = startIndex + modalEntriesPerPage;
  return multipleMaterialsData.materials.slice(startIndex, endIndex);
};

const getModalTotalPages = () => {
  return Math.ceil(multipleMaterialsData.materials.length / modalEntriesPerPage);
};

const handleModalPageChange = (page) => {
  setModalCurrentPage(page);
};

const handleModalEntriesChange = (value) => {
  setModalEntriesPerPage(value === "All" ? multipleMaterialsData.materials.length : Number(value));
  setModalCurrentPage(1);
};

const getModalSerialNumber = (index) => {
  return (modalCurrentPage - 1) * modalEntriesPerPage + index + 1;
};



  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8" >
        <Container fluid >



        <Row className="d-flex justify-content-center align-items-center">
  {/* Total Requests */}
  <Col lg="6" xl="3" className="mb-3">
    <Card className="card-stats mb-1 mb-xl-0" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle className="h4 mb-0">Total Requests</CardTitle>
          <span className="h2 font-weight-bold">{countDetails?.[0]?.total_request ?? 0}</span>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Amount Spent */}
  <Col lg="6" xl="3" className="mb-3">
    <Card className="card-stats mb-4 mb-xl-0" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle className="h4 mb-0">Amount Spent</CardTitle>
          <span className="h2 font-weight-bold">{countDetails?.[0]?.Amount_spent ?? 0}</span>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Approved Request */}
  <Col lg="6" xl="3" className="mb-3">
    <Card className="card-stats mb-4 mb-xl-0" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle className="h4 mb-0">Approved Request</CardTitle>
          <span className="h2 font-weight-bold">{countDetails?.[0]?.Approved_request ?? 0}</span>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Pending Request */}
  <Col lg="6" xl="3" className="mb-3">
    <Card className="card-stats mb-4 mb-xl-0" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle className="h4 mb-0">Pending Request</CardTitle>
          <span className="h2 font-weight-bold">{countDetails?.[0]?.Pending_request ?? 0}</span>
        </div>
      </CardBody>
    </Card>
  </Col>
</Row>
        

          <div className="header bg-gradient-info py-5  ">
            <Container fluid>


              <Row className="mt-5">
                <Col className="mb-5 mb-xl-0" xl="12">
                  <Card className="" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)' }}>

                    <CardBody>

                      <CardHeader className="border-0">
                        {/* MOBILE: xs, sm only */}
                        <div className="d-block d-md-none mb-4">
                          <div className="d-flex flex-column align-items-center gap-3">
                            {/* Header */}
                            <h3 className="mb-0 text-center">Materials List</h3>
                            {/* Dropdown 1 */}
                            <div className="w-100" style={{ maxWidth: 350 }}>
                              <Dropdown isOpen={projectDropdownOpen} toggle={() => setProjectDropdownOpen(!projectDropdownOpen)}>
                                <DropdownToggle caret className="w-100">
                                  {selectedProject === "all"
                                    ? "All Projects"
                                    : (projects.find(p => p.p_id === selectedProject)?.p_name || "Select Project")}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => setSelectedProject("all")}>All Projects</DropdownItem>
                                  {projects.map(project => (
                                    <DropdownItem key={project.p_id} onClick={() => setSelectedProject(project.p_id)}>
                                      {project.p_name}
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            {/* Dropdown 2 */}
                            <div className="w-100" style={{ maxWidth: 350 }}>
                              <Dropdown isOpen={entriesDropdownOpen} toggle={toggleEntriesDropdown}>
                                <DropdownToggle caret className="w-100">
                                  Show Entries: {entriesToShow === filteredDataLength ? "All" : entriesToShow}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                                  <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                                  <DropdownItem onClick={() => handleEntriesChange('All')}>All</DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            {/* Button */}
                            <div className="w-100" style={{ maxWidth: 350 }}>
                              <button
                                className="btn btn-success w-100"
                                style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black', minWidth: 120 }}
                                onClick={handleDownload}
                              >
                                Download
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* TABLET: md only (≥768px and <992px) */}
                        <div className="d-none d-md-block d-lg-none mb-4">
                          {/* Header */}
                          <div className="text-center mb-3">
                            <h3 className="mb-0">Materials List</h3>
                          </div>
                          {/* Dropdowns row */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div style={{ width: '48%' }}>
                              <Dropdown isOpen={projectDropdownOpen} toggle={() => setProjectDropdownOpen(!projectDropdownOpen)}>
                                <DropdownToggle caret className="w-100">
                                  {selectedProject === "all"
                                    ? "All Projects"
                                    : (projects.find(p => p.p_id === selectedProject)?.p_name || "Select Project")}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => setSelectedProject("all")}>All Projects</DropdownItem>
                                  {projects.map(project => (
                                    <DropdownItem key={project.p_id} onClick={() => setSelectedProject(project.p_id)}>
                                      {project.p_name}
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            <div style={{ width: '48%' }}>
                              <Dropdown isOpen={entriesDropdownOpen} toggle={toggleEntriesDropdown}>
                                <DropdownToggle caret className="w-100">
                                  Show Entries: {entriesToShow === filteredDataLength ? "All" : entriesToShow}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                                  <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                                  <DropdownItem onClick={() => handleEntriesChange('All')}>All</DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                          </div>
                          {/* Button row */}
                          <div className="d-flex justify-content-center">
                            <button
                              className="btn btn-success"
                              style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black', minWidth: 120 }}
                              onClick={handleDownload}
                            >
                              Download
                            </button>
                          </div>
                        </div>

                        {/* LAPTOP: lg only (1024px) */}
                        <div className="d-none d-lg-block d-xl-none mb-4">
                          {/* Header row */}
                          <div className="mb-2">
                            <h3 className="mb-0">Materials List</h3>
                          </div>
                          {/* Controls row */}
                          <div className="d-flex align-items-center justify-content-between">
                            <div style={{ width: '32%' }}>
                              <Dropdown isOpen={projectDropdownOpen} toggle={() => setProjectDropdownOpen(!projectDropdownOpen)}>
                                <DropdownToggle caret className="w-100">
                                  {selectedProject === "all"
                                    ? "All Projects"
                                    : (projects.find(p => p.p_id === selectedProject)?.p_name || "Select Project")}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => setSelectedProject("all")}>All Projects</DropdownItem>
                                  {projects.map(project => (
                                    <DropdownItem key={project.p_id} onClick={() => setSelectedProject(project.p_id)}>
                                      {project.p_name}
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            <div style={{ width: '32%' }}>
                              <Dropdown isOpen={entriesDropdownOpen} toggle={toggleEntriesDropdown}>
                                <DropdownToggle caret className="w-100">
                                  Show Entries: {entriesToShow === filteredDataLength ? "All" : entriesToShow}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                                  <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                                  <DropdownItem onClick={() => handleEntriesChange('All')}>All</DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            <div style={{ width: '32%', textAlign: 'right' }}>
                              <button
                                className="btn btn-success"
                                style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black', minWidth: 120 }}
                                onClick={handleDownload}
                              >
                                Download
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* DESKTOP: xl+ (keep as is) */}
                        <Row className="align-items-center d-none d-xl-flex">
                          <div className="col">
                            <h3 className="mb-0">Materials List</h3>
                          </div>
                          <div className="col text-right">
                            <div className="d-flex justify-content-end align-items-center" style={{ flexWrap: 'nowrap', gap: '8px' }}>
                              {/* Date Range Filter */}
                              <Button
                                size="sm"
                                color="info"
                                onClick={toggleDateRangeModal}
                                style={{
                                  backgroundColor: '#d86f89', 
                                  borderColor: '#d86f89', 
                                  color: 'black',
                                  whiteSpace: 'nowrap',
                                  minWidth: 'fit-content'
                                }}
                                className="px-3"
                              >
                                <i className="fas fa-calendar-alt mr-1"></i>
                                {getDateRangeText()}
                              </Button>

                              {/* Material Name Filter */}
                              <Dropdown
                                isOpen={materialFilterDropdownOpen}
                                toggle={toggleMaterialFilterDropdown}
                              >
                                <DropdownToggle caret className="px-3">
                                  {materialNameFilter ? `Material: ${materialNameFilter}` : "Filter by Material"}
                                </DropdownToggle>
                                <DropdownMenu style={{ width: '300px', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                                  {/* Search Bar Inside Dropdown */}
                                  <div className="mb-2">
                                    <Input
                                      type="text"
                                      placeholder="Search materials..."
                                      value={materialSearchQuery || ''}
                                      onChange={(e) => setMaterialSearchQuery(e.target.value)}
                                      style={{ fontSize: '13px', height: '32px' }}
                                    />
                                  </div>
                                  <DropdownItem 
                                    onClick={() => {
                                      setMaterialNameFilter("");
                                      setMaterialSearchQuery("");
                                    }}
                                    style={{ padding: '6px 12px', fontSize: '13px' }}
                                  >
                                    All Materials
                                  </DropdownItem>
                                  {getUniqueMaterialNames().length > 0 ? (
                                    getUniqueMaterialNames().map((name, index) => (
                                      <DropdownItem
                                        key={index}
                                        onClick={() => {
                                          setMaterialNameFilter(name);
                                          setMaterialSearchQuery("");
                                        }}
                                        style={{ 
                                          padding: '6px 12px', 
                                          fontSize: '13px',
                                          backgroundColor: materialNameFilter === name ? '#f8f9fa' : 'transparent',
                                          fontWeight: materialNameFilter === name ? 'bold' : 'normal'
                                        }}
                                      >
                                        {name}
                                      </DropdownItem>
                                    ))
                                  ) : (
                                    <DropdownItem disabled style={{ padding: '6px 12px', fontSize: '13px' }}>
                                      <small className="text-muted">No materials found</small>
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </Dropdown>

                              {/* Clear Filters Button */}
                              {(startDate || endDate || materialNameFilter) && (
                                <Button
                                  size="sm"
                                  color="secondary"
                                  onClick={clearFilters}
                                  className="px-3"
                                >
                                  Clear Filters
                                </Button>
                              )}

                              <Dropdown isOpen={projectDropdownOpen} toggle={() => setProjectDropdownOpen(!projectDropdownOpen)}>
                                <DropdownToggle caret>
                                  {selectedProject === "all"
                                    ? "All Projects"
                                    : (projects.find(p => p.p_id === selectedProject)?.p_name || "Select Project")}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => setSelectedProject("all")}>All Projects</DropdownItem>
                                  {projects.map(project => (
                                    <DropdownItem key={project.p_id} onClick={() => setSelectedProject(project.p_id)}>
                                      {project.p_name}
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>

                              <Dropdown isOpen={entriesDropdownOpen} toggle={toggleEntriesDropdown}>
                                <DropdownToggle caret>
                                  Show Entries: {entriesToShow === filteredDataLength ? "All" : entriesToShow}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                                  <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                                  <DropdownItem onClick={() => handleEntriesChange('All')}>All</DropdownItem>
                                </DropdownMenu>
                              </Dropdown>

                              <button className="btn btn-success" style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} onClick={handleDownload}>Download</button>
                            </div>
                          </div>
                        </Row>
                      </CardHeader>

                      <Table className="align-items-center table-flush" responsive>
                        <thead className="thead-light">


                          <tr style={{ textAlign: "center" }}>
                            <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col"> Sl.No </th>
                            <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col"> Project Name </th>
                            <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col"> Item Name </th>
                            <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col"> Requested By </th>
                            <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col"> Quantity </th>
                            <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col"> Cost </th>
                            <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col"> Priority </th>
                            <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col"> status </th>
                            <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col"> Action </th>
                          </tr>



                        </thead>
                        <tbody style={{ textAlign: "center" }}>
  {dataToShow && dataToShow.length > 0 ? (
    dataToShow.map((item, index) => (
      <tr key={index}>
        <th scope="row">{index + 1}</th>
        <td>{item.p_name || "N/A"}</td>
        <td>
          {item.mat_data ? item.mat_fileName : item.mat_name}
        </td>
        <td>{item.emp_name || "N/A"}</td>
        <td>
          {item.mat_data ? (() => {
            try {
              const matData = JSON.parse(item.mat_data);
              const totalQuantity = matData.reduce((sum, material) => {
                return sum + (parseFloat(material.mat_quantity) || 0);
              }, 0);
              return totalQuantity;
            } catch (error) {
              return "N/A";
            }
          })() : item.mat_quantity}
        </td>
        <td>
          {item.mat_data ? (() => {
            try {
              const matData = JSON.parse(item.mat_data);
              const totalBudget = matData.reduce((sum, material) => {
                const quantity = parseFloat(material.mat_quantity) || 0;
                const price = parseFloat(material.mat_money) || 0;
                return sum + (quantity * price);
              }, 0);
              return `₹${totalBudget.toFixed(2)}`;
            } catch (error) {
              return "N/A";
            }
          })() : item.mat_money}
        </td>
        <td>
          {item.Priority === "Low" ? (
            <Badge color='success'>{item.Priority}</Badge>
          ) : item.Priority === "High" ? (
            <Badge color='danger'>{item.Priority}</Badge>
          ) : (
            <Badge color='warning'>{item.Priority}</Badge>
          )}
        </td>
        <td>
          {getStatusBadge(item.store_status || (item.mat_data ? "pending" : ""))}
        </td>
        <td>
          <button
            className='btn btn-success'
            style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}
            onClick={() => {
              if(item.mat_data){
                const matData = JSON.parse(item.mat_data);
                
                // Check if this is multiple materials (more than 1)
                if (matData.length > 1) {
                  // Multiple materials - show table view
                  const multipleData = {
                    materials: matData,
                    metadata: {
                      Priority: item.Priority,
                      Date_Time: item.Date_Time,
                      mat_status: item.mat_status,
                      store_status: item.store_status,
                      gm_report: item.gm_report,
                      store_report: item.store_report,
                      files: item.files
                    }
                  };
                  setMultipleMaterialsData(multipleData);
                  setIsMultipleMaterials(true);
                  setModalCurrentPage(1);
                  setModalEntriesPerPage(5);
                } else {
                  // Single material - show regular view
                  const merged = {
                    mat_name: matData[0].mat_name,
                    mat_money: matData[0].mat_money,
                    mat_quantity: matData[0].mat_quantity,
                    Priority: item.Priority,
                    Date_Time: item.Date_Time,
                    mat_status: item.mat_status,
                    store_status: item.store_status,
                    gm_report: item.gm_report,
                    store_report: item.store_report,
                    files: item.files
                  };
                  setModalEmployee(merged);
                  setIsMultipleMaterials(false);
                }
              } else {
                // Single material from regular request
                setModalEmployee(item);
                setIsMultipleMaterials(false);
              }
              toggleModalView();
            }}
          >
            <i className="fa-solid fa-eye" style={{ fontSize: '22px' }} ></i>
          </button>
          <button
            className='btn btn-success'
            style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}
            onClick={() => handleItemClick(item.m_id || item.mat_id)}
          >
            Set Action
          </button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" className='text-cenetr'>No data available</td>
    </tr>
  )}
</tbody>
                      </Table>

                      <nav className='mt-3'>
                        <ul className='pagination justify-content-center '>
                          <li className='page-item '>
                            <a href='#' className='page-link text-primary' onClick={(e) => {
                              e.preventDefault();
                              prePage();
                            }}>Prev</a>
                          </li>
                          {(() => {
                            const totalPages = Math.ceil(filteredDataLength / entriesToShow);
                            const pages = [];
                            
                            // Show up to 3 pages around current page
                            const startPage = Math.max(1, currentPage - 1);
                            const endPage = Math.min(totalPages, currentPage + 1);
                            
                            for (let i = startPage; i <= endPage; i++) {
                              pages.push(
                                <li key={i} className='page-item'>
                                  <a 
                                    href='#' 
                                    className={`page-link text-white ${i === currentPage ? 'active' : ''}`} 
                                    style={{ backgroundColor: i === currentPage ? '#5E72E4' : '#5E72E4' }} 
                                    onClick={(e) => {
                                      e.preventDefault();
                                      changeCPage(i);
                                    }}
                                  >
                                    {i}
                                  </a>
                                </li>
                              );
                            }
                            
                            return pages;
                          })()}
                          <li className='page-item'>
                            <a href='#' className='page-link text-primary' onClick={(e) => {
                              e.preventDefault();
                              nextPage();
                            }}>Next</a>
                          </li>
                        </ul>
                      </nav>

                    </CardBody>


                  </Card>
                </Col>
              </Row>


            </Container>
          </div>

          <Modal
            isOpen={showDeleteConfirmation}
            toggle={() => setShowDeleteConfirmation(false)}
          >
            <ModalHeader>Confirm Deletion</ModalHeader>
            <ModalBody>Are you sure you want to delete this role ?</ModalBody>
            <div className="modal-footer">
              <Button color="danger" onClick={handleDeleteConfirmation}>
                Yes
              </Button>
              <Button
                color="secondary"
                onClick={() => setShowDeleteConfirmation(false)}
              >
                No
              </Button>
            </div>
          </Modal>

          <Modal isOpen={showRoleModal} toggle={toggleRole}>
            <ModalHeader toggle={toggleRole}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                New Stock
              </h2>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={handleFormSubmit}>
                <Row>
                  <Col md={12}>
                    <FormGroup>

                      <label className="form-control-label" htmlFor="input-role">
                        Enter Item ID
                      </label>
                      <Input
                        className="form-control-alternative"
                        id="input-role"
                        type="number"
                        name="role"
                        pattern="^[a-zA-Z ]+$"
                        onChange={handleInputChange}
                        placeholder="Enter Item Id" required
                      />

                      <label className="form-control-label" htmlFor="input-role">
                        Enter Item Name
                      </label>
                      <Input
                        className="form-control-alternative"
                        id="input-role"
                        type="text"
                        name="role"
                        pattern="^[a-zA-Z ]+$"
                        onChange={handleInputChange}
                        placeholder="Enter Item Name" required
                      />

                      <label className="form-control-label" htmlFor="input-role">
                        Enter Item Category
                      </label>
                      <Input
                        className="form-control-alternative"
                        id="input-role"
                        type="text"
                        name="role"
                        pattern="^[a-zA-Z ]+$"
                        onChange={handleInputChange}
                        placeholder="Enter Category Name" required
                      />

                      <label className="form-control-label" htmlFor="input-role">
                        Enter Current Stock
                      </label>
                      <Input
                        className="form-control-alternative"
                        id="input-role"
                        type="number"
                        name="role"
                        pattern="^[a-zA-Z ]+$"
                        onChange={handleInputChange}
                        placeholder="Enter Current Stock" required
                      />

                      <label className="form-control-label" htmlFor="input-role">
                        Enter Unit(Kg)
                      </label>
                      <Input
                        className="form-control-alternative"
                        id="input-role"
                        type="number"
                        name="role"
                        pattern="^[a-zA-Z ]+$"
                        onChange={handleInputChange}
                        placeholder="Enter Unit in Kg" required
                      />

                      <label className="form-control-label" htmlFor="input-role">
                        Enter Cost
                      </label>
                      <Input
                        className="form-control-alternative"
                        id="input-role"
                        type="number"
                        name="role"
                        pattern="^[a-zA-Z ]+$"
                        onChange={handleInputChange}
                        placeholder="Enter Cost" required
                      />


                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}><h2 style={{fontWeight:'bolder'}}>Status Action</h2></ModalHeader>
                <ModalBody>
                    {/* Your form elements go here */}
                    <Form onSubmit={handleStatusAction} >
                        <FormGroup>
                            <Label for="exampleSelect">Select</Label>
                            <Input
                                className="form-control-alternative"
                                id="input-status"
                                type="select"
                                name="status"
                                onChange={handleInputChange}
                            >
                                <option value="">Select Status</option>
                                {statusOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="exampleText">Description</Label>
                            <Input type="textarea" name="description" id="exampleText" onChange={handleInputChange} />
                        </FormGroup>
                        <Row>
                            <Col lg='12' style={{ textAlign: 'center' }}>
                                <Button style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} type="submit">Submit</Button>
                            </Col>
                            </Row>
                        {/* Add more form fields as needed */}
                    </Form>
                </ModalBody>
            </Modal>


        </Container>
      </div>

      {modalEmployee && (
  <Modal isOpen={modalOpen} toggle={toggleModalView}>
    <ModalHeader toggle={toggleModalView}>Resource View</ModalHeader>
    <ModalBody>
      <div className="row">
        <div className="col-md-12">
          {/* For file-uploaded materials */}
          {modalEmployee.mat_data ? (
            <>
              <div>
                <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Material Name</label>
                <label className='p-2 rounded font-weight-bold m-1'>:</label>
                <label className='border p-2 rounded '>
                  {JSON.parse(modalEmployee.mat_data).map(mat => mat.mat_name).join(", ")}
                </label>
              </div>
              <div>
                <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Budget</label>
                <label className='p-2 rounded font-weight-bold m-1'>:</label>
                <label className="border p-2 rounded ">
                  {JSON.parse(modalEmployee.mat_data).map(mat => mat.mat_money).join(", ")}
                </label>
              </div>
              <div>
                <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Quantity</label>
                <label className='p-2 rounded font-weight-bold m-1'>:</label>
                <label className="border p-2 rounded ">
                  {JSON.parse(modalEmployee.mat_data).map(mat => mat.mat_quantity).join(", ")}
                </label>
              </div>
            </>
          ) : (
            // For single/manual materials
            <>
              <div>
                <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Material Name</label>
                <label className='p-2 rounded font-weight-bold m-1'>:</label>
                <label className='border p-2 rounded '>{modalEmployee.mat_name}</label>
              </div>
              <div>
                <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Budget</label>
                <label className='p-2 rounded font-weight-bold m-1'>:</label>
                <label className="border p-2 rounded ">
                  {modalEmployee.mat_money}
                </label>
              </div>
              <div>
                <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Quantity</label>
                <label className='p-2 rounded font-weight-bold m-1'>:</label>
                <label className="border p-2 rounded ">
                  {modalEmployee.mat_quantity}
                </label>
              </div>
            </>
          )}
          {/* Add other fields as needed */}
          <div>
            <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Priority</label>
            <label className='p-2 rounded font-weight-bold m-1'>:</label>
            <label className='border p-2 rounded '>{modalEmployee.Priority}</label>
          </div>
          <div>
            <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Date</label>
            <label className='p-2 rounded font-weight-bold m-1'>:</label>
            <label className='border p-2 rounded '>{modalEmployee.Date_Time}</label>
          </div>
          <div>
            <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>General Manager</label>
            <label className='p-2 rounded font-weight-bold m-1'>:</label>
            <label className='border p-2 rounded '>{modalEmployee.mat_status}</label>
          </div>
          <div>
            <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Action</label>
            <label className='p-2 rounded font-weight-bold m-1'>:</label>
            <label className='border p-2 rounded '>{modalEmployee.gm_report}</label>
          </div>
          <div>
            <label className='border p-2 rounded font-weight-bold' style={{ width: '155px' }}>Store Manager</label>
            <label className='p-2 rounded font-weight-bold m-1'>:</label>
            <label className='border p-2 rounded '>{modalEmployee.store_status}</label>
          </div>
        </div>
      </div>
    </ModalBody>
  </Modal>
)}

      {/* Multiple Materials Modal */}
      {multipleMaterialsData && isMultipleMaterials && (
        <Modal isOpen={modalOpen} toggle={toggleModalView} size="xl">
          <ModalHeader toggle={toggleModalView}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <span>Multiple Materials View ({multipleMaterialsData.materials.length} materials)</span>
              <Button
                color="success"
                size="sm"
                onClick={handleDownloadMultipleMaterials}
                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
              >
                <i className="fas fa-download mr-1"></i>
                Download Excel
              </Button>
            </div>
          </ModalHeader>
          <ModalBody>
            {/* Metadata Section */}
            <div className="row mb-4">
              <div className="col-md-12">
                <h6 className="text-muted mb-3">Request Information</h6>
                <div className="row">
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">Priority</small>
                      <strong>{multipleMaterialsData.metadata.Priority || "N/A"}</strong>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">Date</small>
                      <strong>{multipleMaterialsData.metadata.Date_Time || "N/A"}</strong>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">General Manager</small>
                      <strong>{multipleMaterialsData.metadata.mat_status || "N/A"}</strong>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">Store Manager</small>
                      <strong>{multipleMaterialsData.metadata.store_status || "N/A"}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Materials Table */}
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="text-muted mb-0">Materials List</h6>
                  {multipleMaterialsData.materials.length > 5 && (
                    <div className="d-flex align-items-center">
                      <span className="mr-2 text-muted small">Show:</span>
                      <Dropdown
                        isOpen={modalEntriesDropdownOpen}
                        toggle={() => setModalEntriesDropdownOpen(!modalEntriesDropdownOpen)}
                        size="sm"
                      >
                        <DropdownToggle caret size="sm" className="px-3">
                          {modalEntriesPerPage === multipleMaterialsData.materials.length ? "All" : modalEntriesPerPage}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => handleModalEntriesChange(5)}>5</DropdownItem>
                          <DropdownItem onClick={() => handleModalEntriesChange(10)}>10</DropdownItem>
                          <DropdownItem onClick={() => handleModalEntriesChange(15)}>15</DropdownItem>
                          <DropdownItem onClick={() => handleModalEntriesChange("All")}>All</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  )}
                </div>
                <div className="table-responsive" style={{maxHeight: '400px', overflowY: 'auto'}}>
                  <Table striped bordered hover size="sm">
                    <thead className="thead-light" style={{position: 'sticky', top: 0, zIndex: 1}}>
                      <tr>
                        <th style={{width: '5%'}}>Sr. No</th>
                        <th style={{width: '35%'}}>Material Name</th>
                        <th style={{width: '15%'}}>Quantity</th>
                        <th style={{width: '15%'}}>Budget</th>
                        <th style={{width: '10%'}}>Unit Price</th>
                        <th style={{width: '20%'}}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getModalPaginatedMaterials().map((material, index) => {
                        const quantity = parseFloat(material.mat_quantity) || 0;
                        const price = parseFloat(material.mat_money) || 0;
                        const total = quantity * price;
                        
                        return (
                          <tr key={index}>
                            <td>{getModalSerialNumber(index)}</td>
                            <td>
                              <div style={{wordBreak: 'break-word'}}>
                                {material.mat_name || "N/A"}
                              </div>
                            </td>
                            <td>{material.mat_quantity || "N/A"}</td>
                            <td>₹{material.mat_money || "N/A"}</td>
                            <td>₹{price.toFixed(2)}</td>
                            <td>₹{total.toFixed(2)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr className="font-weight-bold" style={{backgroundColor: '#f8f9fa'}}>
                        <td colSpan="5" className="text-right">Total Budget:</td>
                        <td>
                          ₹{multipleMaterialsData.materials.reduce((sum, material) => {
                            const quantity = parseFloat(material.mat_quantity) || 0;
                            const price = parseFloat(material.mat_money) || 0;
                            return sum + (quantity * price);
                          }, 0).toFixed(2)}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
                
                {/* Pagination Controls */}
                {multipleMaterialsData.materials.length > 5 && getModalTotalPages() > 1 && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted small">
                      Showing {((modalCurrentPage - 1) * modalEntriesPerPage) + 1} to {Math.min(modalCurrentPage * modalEntriesPerPage, multipleMaterialsData.materials.length)} of {multipleMaterialsData.materials.length} materials
                    </div>
                    <nav>
                      <ul className="pagination pagination-sm mb-0">
                        <li className={`page-item ${modalCurrentPage === 1 ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handleModalPageChange(modalCurrentPage - 1)}
                            disabled={modalCurrentPage === 1}
                          >
                            Previous
                          </button>
                        </li>
                        {Array.from({ length: getModalTotalPages() }, (_, i) => i + 1).map((pageNumber) => (
                          <li key={pageNumber} className={`page-item ${pageNumber === modalCurrentPage ? 'active' : ''}`}>
                            <button
                              className="page-link"
                              onClick={() => handleModalPageChange(pageNumber)}
                              style={{
                                backgroundColor: pageNumber === modalCurrentPage ? '#d86f89' : 'transparent',
                                borderColor: pageNumber === modalCurrentPage ? '#d86f89' : '#dee2e6',
                                color: pageNumber === modalCurrentPage ? 'white' : '#007bff'
                              }}
                            >
                              {pageNumber}
                            </button>
                          </li>
                        ))}
                        <li className={`page-item ${modalCurrentPage === getModalTotalPages() ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handleModalPageChange(modalCurrentPage + 1)}
                            disabled={modalCurrentPage === getModalTotalPages()}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}

      {/* Date Range Filter Modal */}
      <Modal isOpen={dateRangeModalOpen} toggle={toggleDateRangeModal}>
        <ModalHeader toggle={toggleDateRangeModal}>
          <i className="fas fa-calendar-alt mr-2"></i>
          Filter by Date Range
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="startDate">Start Date</Label>
                  <Input
                    type="date"
                    id="startDate"
                    name="startDate"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="Select start date"
                  />
                  <small className="text-muted">
                    Leave empty to show from beginning
                  </small>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="endDate">End Date</Label>
                  <Input
                    type="date"
                    id="endDate"
                    name="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="Select end date"
                  />
                  <small className="text-muted">
                    Leave empty to show until current date
                  </small>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="d-flex justify-content-between">
                  <Button
                    color="secondary"
                    onClick={clearFilters}
                    size="sm"
                  >
                    Clear Dates
                  </Button>
                  <div>
                    <Button
                      color="secondary"
                      onClick={toggleDateRangeModal}
                      className="mr-2"
                      size="sm"
                    >
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      onClick={applyDateRange}
                      size="sm"
                      style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                    >
                      Apply Filter
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Materials4;








